<template>
  <div class="element">
    <div class="coin_element" :class="{active: active === 'ethereum'}" @click="alertChain">
      <img src="../assets/eth.svg" height="80px">
    </div>
    <div class="coin_element" :class="{active: active === 'binance'}" @click="alertChain">
      <img src="../assets/bnb.svg" height="80px">
    </div>
  </div>
</template>

<script>
import {bus} from "@/main";

export default {
  name: "Input4",
  created() {
    bus.$on('chain-changed', this.chainChanged);
  },
  beforeDestroy() {
    bus.$off('chain-changed', this.chainChanged);
  },
  data: function () {
    return {
      inputValue: 25,
      active: ""
    }
  },
  methods: {
    pay: function () {
      this.$emit('pay', this.inputValue)
    },
    chainChanged: function (chainId) {
      if (chainId == 0x1) {
        this.active = "ethereum"
      } else if (chainId == 0x38) {
        this.active = "binance"
      } else {
        this.active = ""
      }
    },
    alertChain: function () {
      alert("Change network in Metamask")
    }
  }
}
</script>

<style scoped>
.element {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.coin_element {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 20px;
  border: 1px solid rgb(44, 47, 54);
  background-color: rgb(33, 36, 41);
  height: 100px;
  width: 100px;
  margin: 0 10px 0 10px;

  cursor: pointer;
}

.active {
  background-color: rgb(44, 47, 54);
}
</style>